var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',[_c('base-card-part-footer',{attrs:{"slot":"card-footer","place":_vm.getWorkAddress,"name":_vm.getWorkName},slot:"card-footer"}),_c('persona-content',{attrs:{"member":_vm.value.member}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }